module.exports = __webpack_public_path__ + "img/cli_03.eed3294d.png";